/**
 * Site-wide configuration: company facts, navigation IA, and the primary CTAs.
 * Single source of truth for the Header, Footer, and any nav-driven UI.
 */

export const company = {
  name: 'Virginia Rehab Physicians',
  shortName: 'VRP',
  legalName: 'Virginia Rehab Physicians',
  phone: '(804) 220-5770',
  phoneHref: 'tel:+18042205770',
  email: 'info@varehabphysicians.com',
  providerPortalUrl: 'https://app.varehabphysicians.com/',
};

/** Primary navigation, recruit-first, six-page IA. */
export const navItems = [
  { label: 'What We Do', href: '/what-we-do' },
  { label: 'About', href: '/about' },
  { label: 'Team', href: '/team' },
  { label: 'Careers', href: '/careers' },
];

/** Header CTA. */
export const primaryCta = {
  label: 'Get in touch',
  href: '/contact',
};

/** Provider sign-in, external app shell for the custom clinical tools. */
export const providerPortal = {
  label: 'Provider Portal',
  href: company.providerPortalUrl,
};

/** Recruiting CTA used across the site. */
export const recruitingCta = {
  label: 'Explore joining VRP',
  href: '/careers',
};

/** Footer link columns. */
export const footerNav = [
  {
    heading: 'Explore',
    links: [
      { label: 'What We Do', href: '/what-we-do' },
      { label: 'About', href: '/about' },
      { label: 'Team', href: '/team' },
    ],
  },
  {
    heading: 'Physicians',
    links: [
      { label: 'Careers at VRP', href: '/careers' },
      { label: 'Your first 90 days', href: '/careers#first-90-days' },
      { label: 'Provider Portal', href: company.providerPortalUrl, external: true },
    ],
  },
  {
    heading: 'Contact',
    links: [
      { label: 'Contact Us', href: '/contact' },
      { label: 'Hospital partnerships', href: '/contact?audience=facility' },
    ],
  },
];
